import './widget.scss';

import DestinationWidget from './widgets/destination';
import DevelopWidget from './widgets/developer';
import LoggingWidget from './widgets/logging';
import { AutonomousModeWidget } from './widgets/mode';
import NaviWidget from './widgets/navigation';
import { useSendUserInput } from '../../provider/socketContext';
import { useEffect } from 'react';
import { useDisplayStore, useRemoteStore } from '../../store/sceneStore';

export function AutonomousWidgetManager() {
	const display = useDisplayStore();
	const remote = useRemoteStore();

	const sendUserInput = useSendUserInput();

	if (remote.request === 2) {
		return null;
	}

	useEffect(() => {
		if (remote.request === 0) {
			const interval = setInterval(() => {
				sendUserInput({ type: 'user_input', text: 'approval', value: 0 });
			}, 1000);
			return () => clearInterval(interval);
		}
	}, [remote.request]);

	return (
		<>
			<div className={`Modal ${display.mode ? 'Show' : ''}`}>
				<AutonomousModeWidget />
				<DevelopWidget />
				<NaviWidget />
				<DestinationWidget />
			</div>
			<LoggingWidget />
		</>
	);
}
